module.exports = __webpack_public_path__ + "static/media/abanca_logo.dfd90170.svg";